import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../components/Hyperlink';
import { Connect, PropsFromRedux } from './NavDemoContainer';
import { doctrineAnalytics } from '../../utils/analyticsUtils';

import './nav_demo.scss';

type Props = PropsFromRedux;

export class RawNavDemo extends React.Component<Props> {
  askDemo = () => {
    doctrineAnalytics('AskDemoClicked', { source: 'header' });
  };

  render() {
    const { displayDemo } = this.props;
    return (
      displayDemo && (
        <Hyperlink
          href="/demo"
          source="header"
          target="_blank"
          className="button clear secondary nav-demo__pulsating hide_on--mobile"
          onClick={this.askDemo}
        >
          <span className="nav-demo__pulsating--circle" />
          <span className="nav-demo__pulsating--small-circle" />
          <span className="nav-demo__pulsating--text">
            <FormattedMessage id="demo/nav/NavDemo.tsx/1" />
          </span>
        </Hyperlink>
      )
    );
  }
}

export const NavDemo = Connect(RawNavDemo);
